module.exports = __webpack_public_path__ + "static/media/dev-2.9f29aa4b.png";